import { forwardRef } from 'react';
import { FontAwesomeIcon as OriginalFontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Icon, type IconProps } from '@mui/material';
import type { FontAwesomeIconProps as OriginalFontAwesomeIconProps } from '@fortawesome/react-fontawesome';

type FontAwesomeIconProps = Omit<OriginalFontAwesomeIconProps, 'color' | 'fontSize'> & Pick<IconProps, 'color' | 'ref' | 'fontSize'>;

export const FontAwesomeIcon = forwardRef<SVGSVGElement, FontAwesomeIconProps>(({ className = '', ...restProps }, ref: any) => (
  <Icon
    ref={ref}
    className={className}
    component={OriginalFontAwesomeIcon}
    {...restProps}
  />
));
